<template>
  <div :class="`m-portal .m-portal-${routeType}-nav ${currentModule}`">
    <div class="left-menu">
      <div class="menu-title">文化概述</div>
      <div class="menu-items">
        <div v-if="['zzwh'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="culture('culture','zzwh','2648fa10-2354-4527-a6e7-fe583b008c03')"
            style="font-weight: bold;"
            class="waves"
          >
            文化内涵
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a
            @click="culture('culture','zzwh','2648fa10-2354-4527-a6e7-fe583b008c03')"
            class="waves"
          >
            文化内涵
            <span>></span>
          </a>
        </div>
        <div v-if="['info'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleCultPage('life-resume','info')" style="font-weight: bold;" class="waves">
            朱子年谱
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleCultPage('life-resume','info')" class="waves">
            朱子年谱
            <span>></span>
          </a>
        </div>
        <div v-if="['zzlx','zzlx_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','zzlx')" style="font-weight: bold;" class="waves">
            朱子理学
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzlx')" class="waves">
            朱子理学
            <span>></span>
          </a>
        </div>
        <div v-if="['jdxb','jdxb_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','jdxb')" style="font-weight: bold;" class="waves">
            经典选编
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','jdxb')" class="waves">
            经典选编
            <span>></span>
          </a>
        </div>
        <div v-if="['zzgs','zzgs_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','zzgs')" style="font-weight: bold;" class="waves">
            朱子故事
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzgs')" class="waves">
            朱子故事
            <span>></span>
          </a>
        </div>
        <div v-if="['zzln','zzln_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','zzln')" style="font-weight: bold;" class="waves">
            政治理念
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzln')" class="waves">
            政治理念
            <span>></span>
          </a>
        </div>
        <div v-if="['zzsj','zzsj_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','zzsj')" style="font-weight: bold;" class="waves">
            政治实践
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzsj')" class="waves">
            政治实践
            <span>></span>
          </a>
        </div>
        <div v-if="['jysx','jysx_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','jysx')" style="font-weight: bold;" class="waves">
            教育思想
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','jysx')" class="waves">
            教育思想
            <span>></span>
          </a>
        </div>
        <div v-if="['whyc_page','whyc_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiPage('article','whyc_page')"
            style="font-weight: bold;"
            class="waves"
          >
            文化遗存
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','whyc_page')" class="waves">
            文化遗存
            <span>></span>
          </a>
        </div>
        <div v-if="['lxcb'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiSingle('single-article','lxcb')"
            style="font-weight: bold;"
            class="waves"
          >
            理学传播
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiSingle('single-article','lxcb')" class="waves">
            理学传播
            <span>></span>
          </a>
        </div>
        <div v-if="['kw'].indexOf($route.params._field)>-1" class="menu-item">
          <a @click="handleArtiPage('article','kw')" style="font-weight: bold;" class="waves">
            朱子刊物
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','kw')" class="waves">
            朱子刊物
            <span>></span>
          </a>
        </div>
        <!-- <div v-if="['whjt_page','whjt_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiPage('article','whjt_page')"
            style="font-weight: bold;"
            class="waves"
          >
            文化讲坛
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','whjt_page')" class="waves">
            文化讲坛
            <span>></span>
          </a>
        </div> -->
        <div v-if="['zzsl_page','zzsl_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiPage('article','zzsl_page')"
            style="font-weight: bold;"
            class="waves"
          >
            朱子四礼
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzsl_page')" class="waves">
            朱子四礼
            <span>></span>
          </a>
        </div>
        <div v-if="['zzzg'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiSingle('single-article','zzzg')"
            style="font-weight: bold;"
            class="waves"
          >
            朱子之歌
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiSingleref('single-article','zzzg')" class="waves">
            朱子之歌
            <span>></span>
          </a>
        </div>
        <!-- <div v-if="['zzcp','zzcp_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            @click="handleArtiPage('article','zzcp')"
            style="font-weight: bold;"
            class="waves"
          >
            朱子产品
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','zzcp')" class="waves">
            朱子产品
            <span>></span>
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      routeType: "cult",
      activeIndex: {}
    };
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  methods: {
    handleCultList(moudle, field) {
      this.$router.push({
        path: `/portal/cult/list/${moudle}/${field}`
      });
    },
    handleArtiPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/arti/page/${moudle}/${field}`
      });
    },
    handleCultPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/cult/page/${moudle}/${field}`
      });
    },
    handleArtiSingleref(moudle, field) {
      // this.$router.push({
      //   path: `/portal/arti/single/${moudle}/${field}`
      // });
      window.location.href = `/portal/arti/single/${moudle}/${field}`;
    },
    handleArtiSingle(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/arti/single/${moudle}/${field}`
      });
      //window.location.href = `/portal/arti/single/${moudle}/${field}`
    },
    handleCultDetail(moudle, field, item) {
      this.$router.push({
        path: `/portal/cult/detail/${moudle}/${field}/${item.cultId}`
      });
    },
    handleArtiList(moudle, field) {
      this.$router.push({
        path: `/portal/arti/list/${moudle}/${field}`
      });
    },
    culture(moudle, field, cultId) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/cult/detail/${moudle}/${field}/${cultId}`
      });
    },
    handleArtiDetail(moudle, field, item) {
      this.$router.push({
        path: `/portal/arti/detail/${moudle}/${field}/${item.artiId}`
      });
    }
  },
  created() {}
};
</script>

<style scoped>
</style>